import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { LoadingService } from 'src/app/core/services/loading.service';
import { ModalService } from 'src/app/core/services/modal.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { TimelineResponse } from '../../models/timeline';
import { TimelineService } from '../../services/timeline.service';
import { AddTimelineComponent } from '../add-timeline/add-timeline.component';

@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss'],
})
export class TimelineComponent implements OnInit {
  list: Array<TimelineResponse> = [];
  querySubs: Subscription;
  farmId: number;
  cropId: number;
  height: number = 230;
  databaseError: boolean = false;
  loading: boolean = true;
  constructor(
    private modalService: ModalService,
    private activatedRoute: ActivatedRoute,
    private loadingService: LoadingService,
    private translateService: TranslateService,
    private timelineService: TimelineService,
    private storageService: StorageService) { }

  ngOnInit() { }
  ionViewDidEnter() {
    this.querySubs = this.activatedRoute.queryParams.subscribe(e => {
      if (e["farmId"]) {
        this.farmId = +e["farmId"];
      }
      if (e["cropId"]) {
        this.cropId = +e["cropId"];
      }
      this.getList();
    });
  }

  ionViewDidLeave() {
    if (typeof this.querySubs != "undefined") {
      this.querySubs.unsubscribe();
    }
  }
  getList() {
    this.list = [];
    this.loading = true;
    this.loadingService.showLoading();
    this.timelineService.getTimelineList(this.farmId, this.cropId).subscribe(res => {
      this.loadingService.hideLoading();
      this.loading = false;
      if (res.IsSuccess) {
        this.list = res.Data;
        this.databaseError = false;
        setTimeout(() => {
          let div = document.getElementById("timeline-header");
          this.height = div.clientHeight + 88;
        }, 100);
      } else {
        this.databaseError = true;
      }
    }, err => {
      this.databaseError = true;
      this.loading = false;
      this.loadingService.hideLoading();
    });
  }

  addStage(item?: TimelineResponse) {
    let modalId = Date.now();
    this.modalService.presentModal({
      component: AddTimelineComponent,
      id: modalId,
      componentProps: {
        farmId: this.farmId,
        date: item?.TimeLineLogDate,
        stageTypeId: item?.StageTypeId,
        stageTypeName: item?.StageTypeName,
        cropId: this.cropId,
        timelineId: item ? item.Id : 0
      },
      options: {
        cssClass: "center-modal"
      }
    }).then(modal => {
      modal.modalObj.onDidDismiss().then(e => {
        console.log("e",e);
        
        if (e.role == "success") {
          this.getList();
          this.storageService.lastFilizFarmId = null;
          this.storageService.lastTrapFarmId = null;
        }
      });
    });
  }
}
